import { useEffect } from 'react';
import { MESSAGE_EVENT, MESSAGE_TYPES } from '../constants/simulationConstants';
import { useSimulationContext } from '../providers/SimulationProvider';

function useRequestedUserEmotionListener(
  convaiClient,
  isEmotionRecognitionEnabled
) {
  const { setUserEmotion } = useSimulationContext();

  useEffect(() => {
    const handleMessage = (event) => {
      try {
        let receivedData = event.data;

        // Parse JSON if string
        if (typeof receivedData === 'string') {
          try {
            receivedData = JSON.parse(receivedData);
          } catch (err) {
            return;
          }
        }

        if (receivedData.type !== MESSAGE_TYPES.REQUEST_USER_EMOTION) return;

        const requestedEmotion = receivedData.payload?.emotion
          ?.trim()
          ?.toLowerCase();
        const requestedEvent = receivedData.payload?.event;
        if (
          requestedEvent === MESSAGE_EVENT.USER_EMOTION_INTERVAL &&
          requestedEmotion
        ) {
          const emotionMessage = `Context: The user is feeling ${requestedEmotion}. Mirror this emotion in your tone and perspective while providing your response.`;
          convaiClient.current.sendTextChunk(emotionMessage);
          console.log('[Emotion Interval] Sending Emotion:', requestedEmotion);
        }

        setUserEmotion(requestedEmotion);
      } catch (error) {
        console.error('[Emotion Interval Error]:', error);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEmotionRecognitionEnabled]);
}

export default useRequestedUserEmotionListener;
